import React, { createContext, useContext } from 'react';
import { app, db, storage, auth, analytics } from './config';

const FirebaseContext = createContext(null);

// Create mock Firebase for development or when real Firebase fails
const createMockFirebase = () => {
  console.log('Using mock Firebase services');
  return {
    app: null,
    db: { 
      collection: () => ({ 
        doc: () => ({ 
          get: async () => ({ exists: false, data: () => ({}) })
        }),
        get: async () => ({ 
          empty: true, 
          docs: [],
          forEach: () => {} 
        })
      }) 
    },
    storage: { 
      ref: () => ({ 
        put: async () => ({}),
        getDownloadURL: async () => "/placeholder-image.jpg" 
      }) 
    },
    auth: { 
      currentUser: null,
      onAuthStateChanged: (callback) => callback(null)
    },
    analytics: { 
      logEvent: () => {} 
    }
  };
};

export const FirebaseProvider = ({ children }) => {
  // Determine if we should use real Firebase or mock
  let firebase;
  
  // Check if Firebase initialization was successful
  if (app) {
    firebase = {
      app,
      db,
      storage,
      auth,
      analytics
    };
    console.log('Using real Firebase services');
  } else {
    firebase = createMockFirebase();
  }

  return (
    <FirebaseContext.Provider value={firebase}>
      {children}
    </FirebaseContext.Provider>
  );
};

export const useFirebase = () => {
  const firebase = useContext(FirebaseContext);
  
  if (!firebase) {
    throw new Error('useFirebase must be used within a FirebaseProvider');
  }
  
  return firebase;
};